export const UserMeEN = [
  [
    {
      balloon: '<span class="emoji">😳</span> What happened, what did I do?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😭</span> Yes… You’re right, how can I fix this?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😰</span>  Come on, Mars is just a trip! '
    }
  ],
  [
    {
      balloon: '<span class="emoji">😍</span>'
    }
  ],
  [
    {
      balloon: 'With what we eat?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🤐</span> my lips are sealed!',
      toggleAvatar: true
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😱</span>'
    }
  ],
  [
    {
      balloon: 'Feeding the hungry, obviously! <span class="emoji">💁</span>'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🙀</span>'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🤔</span> Cars don’t eat food...'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😑</span> What?!?!?! These puzzles are impossible!'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🙋</span> Then how can we solve them?'
    }
  ],
  [
    {
      balloon: 'Ok! I’m taking notes! <span class="emoji">✍️</span>'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🎉</span> Thanks everyone, for coming together and solving our problems!'
    }
  ],
  [
    {
      balloon: 'I’m getting hungry from this problem solving, can we have a little snack? '
    }
  ],
  [
    {
      balloon: 'Ok, let’s go ahead!'
    }
  ],
  [
    {
      balloon: 'Let’s go!'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">✌</span> My bags are packed! '
    }
  ],
  [
    {
      balloon: 'Ok, let’s go ahead!'
    }
  ],
  [
    {
      balloon: 'Ok, let’s go ahead!'
    }
  ],
  [
    {
      balloon: '🙌 Definitely! '
    }
  ],
  [
    {
      balloon: '🥺 Our future? '
    },
    {
      balloon: 'You forgive me? 🥺'
    }
  ]
]
